import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import WerewolveGame from "./pages/werewolve-game/WerewolveGame";
import GameCreation from "./pages/game-creation/GameCreation";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primeicons/primeicons.css";

export class App extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <Router>
        <Routes>
          <Route path="/game" element={<WerewolveGame />} />
          <Route path="/" exact element={<GameCreation />} />
        </Routes>
      </Router>
    );
  }
}
